<template>
  <div>
    <v-card-text>
      <v-form>

        <v-text-field
          ref="newPassword"
          v-model="newPassword" label="Your new password"
          name="newPassword" type="password" data-vv-delay="500"
          v-validate="'required|isStrong'" autofocus
          :error-messages="externalValidationErrors['newPassword'] || errors.collect('newPassword')"
          @keyup.enter.prevent="submit"
          @keypress="clearMessages"
        >
        </v-text-field>

        <v-text-field
          v-model="confirmPassword" label="Confirm password"
          name="confirmPassword" type="password" data-vv-delay="500"
          v-validate="'required|isSame:newPassword'"
          :error-messages="errors.collect('confirmPassword')"
          @keyup.enter.prevent="submit"
          @keypress="clearMessages"
        >
        </v-text-field>

      </v-form>
    </v-card-text>
    <v-card-actions class="mr-2">
      <v-spacer></v-spacer>
      <v-btn color="secondary" @click.native="submit" :disabled="loading">
        {{ buttonLabel }}
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>

export default {
  name: 'MPayPasswordForm',

  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    submitCallback: {
      type: Function,
      required: true,
    },
    buttonLabel: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    newPassword: '',
    confirmPassword: '',
  }),

  computed: {
    externalValidationErrors() {
      const result = {};
      if (this.$store.getters.validationErrors) {
        this.$store.getters.validationErrors.forEach((e) => {
          result[e.field] = e.message;
        });
        return result;
      }
      return false;
    },
  },

  methods: {
    submit() {
      this.$validator.validateAll()
        .then((isValid) => {
          if (isValid) {
            this.submitCallback(this.newPassword);
          }
        });
    },
  },

};
</script>



// WEBPACK FOOTER //
// src/components/MPayPasswordForm.vue